import React from 'react'
import PropTypes from 'prop-types'
import { IconSLIWrapper } from './IconSLIWrapper'

export const IconEmailSend = ({
  className,
  'data-mu-test': dataAttributeTest,
  'data-tip': dataTip
}) => {
  return (
    <IconSLIWrapper
      className={className}
      data-mu-test={dataAttributeTest}
      data-tip={dataTip}
    >
      <svg preserveAspectRatio='xMidYMid' viewBox='0 0 23.938 15.94'>
        <path
          shapeRendering='geometricPrecision'
          fill='currentColor'
          fillRule='evenodd'
          d='M23.929,2.662 L22.596,13.516 C22.452,14.861 21.287,15.926 19.945,15.926 L6.980,15.926 C6.429,15.926 5.982,15.481 5.982,14.933 C5.982,14.384 6.449,14.030 7.000,14.030 L20.000,14.030 C20.313,14.030 20.577,13.630 20.613,13.290 L21.823,3.448 L13.630,10.706 C13.447,10.869 13.211,10.958 12.967,10.958 C12.947,10.958 12.928,10.957 12.908,10.955 C12.644,10.940 12.397,10.821 12.221,10.624 L4.237,1.681 C4.203,1.643 4.190,1.595 4.163,1.553 C4.124,1.494 4.082,1.439 4.057,1.371 C4.031,1.303 4.025,1.234 4.014,1.163 C4.007,1.114 3.985,1.071 3.985,1.020 C3.985,1.010 3.991,1.002 3.991,0.992 C3.993,0.918 4.016,0.850 4.034,0.779 C4.049,0.723 4.053,0.666 4.077,0.615 C4.100,0.564 4.140,0.522 4.172,0.474 C4.213,0.414 4.249,0.351 4.302,0.301 C4.310,0.294 4.313,0.284 4.320,0.278 C4.358,0.244 4.406,0.231 4.447,0.204 C4.507,0.165 4.563,0.123 4.631,0.098 C4.699,0.072 4.769,0.066 4.841,0.055 C4.889,0.048 4.933,0.027 4.983,0.027 L21.441,0.027 C22.160,0.027 22.850,0.335 23.335,0.872 C23.789,1.374 24.000,2.010 23.929,2.662 ZM7.206,2.014 L13.049,8.561 L20.438,2.014 L7.206,2.014 ZM6.980,5.989 C6.980,6.538 6.533,6.983 5.982,6.983 L2.989,6.983 C2.438,6.983 1.991,6.538 1.991,5.989 C1.991,5.440 2.438,4.995 2.989,4.995 L5.982,4.995 C6.533,4.995 6.980,5.440 6.980,5.989 ZM7.978,8.970 C7.978,9.519 7.531,9.964 6.980,9.964 L0.993,9.964 C0.442,9.964 -0.005,9.519 -0.005,8.970 C-0.005,8.421 0.442,7.976 0.993,7.976 L6.980,7.976 C7.531,7.976 7.978,8.421 7.978,8.970 ZM3.986,10.958 L8.976,10.958 C9.527,10.958 9.973,11.402 9.973,11.951 C9.973,12.500 9.527,12.945 8.976,12.945 L3.986,12.945 C3.435,12.945 2.989,12.500 2.989,11.951 C2.989,11.402 3.435,10.958 3.986,10.958 Z'
        />
      </svg>
    </IconSLIWrapper>
  )
}

IconEmailSend.propTypes = {
  className: PropTypes.string,
  'data-mu-test': PropTypes.string,
  'data-tip': PropTypes.string
}
